import request from '@/utils/request'
import { applicationName } from '@/utils/const.js'

/**
 * 提交体验官申请
 */
export function ambassadorApplication(data) {
  return request({
    url: applicationName + '/web/ambassador/submit',
    method: 'post',
    data
  })
}

/**
 * 上传作品图片（FormData 方式）
 * @param {File} file - 图片文件
 * @returns {Promise} 返回 { url: 'pepcoWeb/pict/xxx.jpg' }
 */
export function uploadAmbassadorImage(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: applicationName + '/web/ambassador/uploadImage',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * 获取体验官申请信息（预留）
 */
export function getAmbassadorInfo() {
  return request({
    url: applicationName + '/web/ambassador/info',
    method: 'get'
  })
}

// ==================== 后台管理接口 ====================

/**
 * 分页查询申请列表（管理后台用）
 * @param {Object} params - { page, limit, status, search }
 */
export function getAmbassadorList(params = {}) {
  return request({
    url: applicationName + '/web/ambassador/list',
    method: 'get',
    params
  })
}

/**
 * 查询单条申请详情
 * @param {String} id - 申请ID
 */
export function getAmbassadorDetail(id) {
  return request({
    url: applicationName + '/web/ambassador/detail/' + id,
    method: 'get'
  })
}

/**
 * 更新申请状态
 * @param {String} id - 申请ID
 * @param {String} status - 状态值: pending/approved/rejected/completed
 */
export function updateAmbassadorStatus(id, status) {
  return request({
    url: applicationName + '/web/ambassador/' + id + '/status',
    method: 'put',
    data: { status }
  })
}

/**
 * 删除申请
 * @param {String} id - 申请ID
 */
export function deleteAmbassador(id) {
  return request({
    url: applicationName + '/web/ambassador/' + id,
    method: 'delete'
  })
}
